import { LocationData } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { baseChart } from './baseChart';
import mapData from '@highcharts/map-collection/countries/us/us-all.topo.json';
import { CA_LIGHT_BLUE_COLOR, CA_DARK_BLUE_COLOR } from '@utils/colorGenerator';
import Highcharts from 'highcharts';

export const buildChartOptions = (
  sortedDataItems: LocationData[]
): Highcharts.Options => ({
  ...baseChart,

  colorAxis: {
    type: 'linear',
    minColor: CA_LIGHT_BLUE_COLOR,
    maxColor: CA_DARK_BLUE_COLOR,
  },

  series: [
    {
      type: 'map',
      name: 'Basemap',
      mapData,
    },
    {
      type: 'map',
      data: sortedDataItems.map(dataItem => ({
        value: dataItem.visitIndex,
        code: dataItem.location.toUpperCase(),
      })),
      dataLabels: {
        enabled: true,
        format: '{point.code}',
        color: '#FFFFFF',
        style: {
          textOutline: 'none',
        },
      },
      joinBy: ['postal-code', 'code'],
      mapData,
    },
  ],

  tooltip: {
    enabled: true,
    headerFormat: '',
  },

  xAxis: undefined,
});
